const ROLE = "role";
const FIRST_NAME = "firstName";
const LAST_NAME = "lastName";
const TOKEN = "token";
const REFRESH_TOKEN = "refreshToken";
const REFRESH_TOKEN_EXPIRATION = "refreshTokenExpiration";
const USER_ID = "id";
const EMAIL = "email";
const USERNAME = "username";
const PHONE_NUMBER = "phoneNumber";
const LAST_VISITED_URL = "lastUrl";
const CURRENT_URL = "currentUrl";
const WILDCARD = "wildcard";
const START_DATE = "startDate";
const END_DATE = "endDate";
const STATUS = "status";
const CLINIC_ID = "clinic_id";
const PERMISSIONS = "permissions";
const CLINIC = "clinic";
const LOGO = "logo";
const NEED_TO_CHANGE_PASSWORD = "needToChangePassword";
const USER_FILTERING_WILDCARD = "user_wildcard";
export const ADDRESS_NUMBER = "address_number";
export const ADDRESS = "address";
export const CLINIC_NAME = "clinic_name";
export const CLINIC_SHORT_NAME = "clinic_short_name";
export const GOOGLE_ID = "google_id";
export const SUBSCRIBE_TO_EMAILS = "subscribe_to_email";
export const BANNER = "banner";
export const LAST_PET_INDEX = "last_pet_index";
export const LAST_APPOINTMENT_INDEX = "last_appointment_index";
export const BUSINESS = "businessAccount";
export const CALENDAR_VIEW = "calendar_view";
export const IS_PASSWORD_EMPTY = "is_password_empty"

export {
  CLINIC_ID,
  USER_ID,
  ROLE,
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  USERNAME,
  PHONE_NUMBER,
  TOKEN,
  REFRESH_TOKEN,
  REFRESH_TOKEN_EXPIRATION,
  LAST_VISITED_URL,
  WILDCARD,
  START_DATE,
  END_DATE,
  STATUS,
  PERMISSIONS,
  CLINIC,
  LOGO,
  NEED_TO_CHANGE_PASSWORD,
  USER_FILTERING_WILDCARD,
  CURRENT_URL,
};
